import { IImage } from 'shared/models/media';

export interface IHashtagInfo {
  id: string;
  name: string;
  description: string;

  followerCount: number;
  viewsCount: number;
  talkCount: number;

  background?: IImage;
  streamTabList: { tabName: string; category: number }[];
}

export enum EHashtagUnavailableReason {
  NOT_FOUND = 'not_found',
  SERVER_ERROR = 'server_error',
}

export interface IHashtagUnavailableInfo {
  hashtagId: string;
  unavailableReason: EHashtagUnavailableReason;
}

export type THashtagInfo = IHashtagInfo | IHashtagUnavailableInfo;

export const HashtagInfoUtil = {
  isAvailable: (hashtag: THashtagInfo): hashtag is IHashtagInfo => {
    return !('unavailableReason' in hashtag);
  },
};
